// Servicio de LiveKit para el frontend
// Se comunica con gestor-api para obtener tokens y gestionar grabaciones

import { gestorInstance } from "@/plugins/axios";

const LiveKitService = {
  /**
   * Obtiene los detalles de conexión para unirse a una sala
   * @param {string} roomName - Nombre de la sala
   * @param {string} participantName - Nombre del participante
   * @param {string} participantIdentity - Identidad única del participante
   * @param {string} metadata - Metadatos adicionales (opcional)
   * @param {boolean} isModerator - Si es moderador (opcional)
   * @returns {Promise<Object>} Detalles de conexión incluyendo token y url
   */
  async getConnectionDetails(
    roomName,
    participantName,
    participantIdentity,
    metadata = "",
    isModerator = false
  ) {
    try {
      const response = await gestorInstance.post(`/livekit/token`, {
        roomName,
        participantName,
        participantIdentity,
        metadata,
        isModerator,
      });
      return response;
    } catch (error) {
      console.error("Error obteniendo token de LiveKit:", error);
      throw error;
    }
  },

  /**
   * Inicia la grabación de una sala
   * @param {string} roomName - Nombre de la sala
   * @param {string} layout - Layout de grabación (speaker, grid, dark)
   * @returns {Promise<Object>} Información de la grabación
   */
  async startRecording(roomName, layout = "speaker") {
    try {
      const response = await gestorInstance.post(`/livekit/start-recording`, {
        roomName,
        layout,
      });
      return response;
    } catch (error) {
      console.error("Error iniciando grabación:", error);
      throw error;
    }
  },

  /**
   * Detiene una grabación activa
   * @param {string} egressId - ID de la grabación
   * @returns {Promise<Object>} Resultado de la operación
   */
  async stopRecording(egressId) {
    try {
      const response = await gestorInstance.post(`/livekit/stop-recording`, {
        egressId,
      });
      return response;
    } catch (error) {
      console.error("Error deteniendo grabación:", error);
      throw error;
    }
  },

  /**
   * Obtiene el estado de la sala (incluye si está grabando)
   * @param {string} roomName - Nombre de la sala
   * @returns {Promise<Object>} Estado de la sala
   */
  async getRecordingStatus(roomName) {
    try {
      const response = await gestorInstance.get(
        `/livekit/room/${roomName}/status`
      );
      return response;
    } catch (error) {
      console.error("Error obteniendo estado de sala:", error);
      throw error;
    }
  },

  /**
   * Elimina la sala (desconecta a todos los participantes)
   * @param {string} roomName - Nombre de la sala
   * @returns {Promise<Object>} Resultado de la operación
   */
  async removeParticipants(roomName) {
    try {
      const response = await gestorInstance.delete(`/livekit/room/${roomName}`);
      return response;
    } catch (error) {
      console.error("Error eliminando sala:", error);
      throw error;
    }
  },
};

export default LiveKitService;
